module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-alert', {
    attrs: {
      "title": _vm.title,
      "type": _vm.type,
      "description": _vm.description,
      "closable": false,
      "show-icon": ""
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f031aec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/alert.vue
// module id = 1419
// module chunks = 45